import { Center, Loader } from '@mantine/core'

import ResetPasswordForm from '../components/ResetPasswordForm.component'
import useValidateMagicToken from '../hooks/useValidateMagicToken.hook'

const ResetPasswordView = () => {
  const { isSuccess } = useValidateMagicToken()
  return (
    <>
      {isSuccess ? (
        <ResetPasswordForm />
      ) : (
        <Center>
          <Loader size="lg" />
        </Center>
      )}
    </>
  )
}

export default ResetPasswordView
